import IAirdropTask from '../interfaces/IAirdropTask';

export default class AirdropTask implements IAirdropTask {
    id: string = '';
    title: string = '';
    desc: string = '';
    icon: string = '';
    status: string = 'Pending';
    reward: number = 0;
    multiplier: boolean = false;
    redirect_url: string = '';
    cta: string = '';
    coming_soon: boolean = false;
    moons: number = 0;
}